import { render, staticRenderFns } from "./TaskQuizForm.vue?vue&type=template&id=76297230&"
import script from "./TaskQuizForm.vue?vue&type=script&lang=js&"
export * from "./TaskQuizForm.vue?vue&type=script&lang=js&"
import style0 from "./TaskQuizForm.vue?vue&type=style&index=0&id=76297230&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports